<template>
    <div>
        <template v-if="useBedsCount && !limited">
            <tooltip v-if="includeBedroomsCount && property.bedrooms && property.bedrooms > 1" title="Bedrooms">
                <span :class="marginCssClass"><door-icon :size="14"/> {{ property.bedrooms }}</span>
            </tooltip>
            <tooltip v-if="property.beds" title="Beds">
                <span :class="marginCssClass"><bedroom-icon :size="14"/> {{ property.beds }}</span>
            </tooltip>
        </template>
        <template v-else>
            <tooltip v-if="property.bedrooms" title="Bedrooms">
                <span :class="marginCssClass"><bedroom-icon :size="14"/> {{ property.bedrooms }}</span>
            </tooltip>
        </template>
        <tooltip v-if="property.bathrooms" title="Bathrooms">
            <span :class="marginCssClass"><shower-icon :size="14"/> {{ property.bathrooms }}</span>
        </tooltip>
        <tooltip v-if="property.maxOccupancy" title="Maximum Occupancy">
            <span :class="marginCssClass"><people-icon :size="14"/> {{ property.maxOccupancy }}</span>
        </tooltip>
        <tooltip v-if="!limited && petsLabel" :title="petsLabel">
            <span :class="marginCssClass"><pet-icon :size="14"/></span>
        </tooltip>
        <tooltip v-if="property.hasPool" title="Pool">
            <span :class="limited ? null : marginCssClass"><pool-icon :size="14"/></span>
        </tooltip>
        <tooltip v-if="!limited && property.hasHotTub" title="Hot Tub">
            <span :class="marginCssClass"><hot-tub-icon :size="14"/></span>
        </tooltip>
        <tooltip v-if="!limited && property.hasSkiInOut" title="Ski in/out">
            <span :class="marginCssClass"><ski-icon :size="14"/></span>
        </tooltip>
        <tooltip v-if="!limited && property.hasTennisCourt" title="Tennis Court">
            <span :class="marginCssClass"><tennis-icon :size="14"/></span>
        </tooltip>
        
    </div>
</template>

<script type="text/javascript">
    import DoorIcon from '@/assets/icons/door.svg.vue';
    import BedroomIcon from '@/assets/icons/bedroom.svg.vue';
    import ShowerIcon from '@/assets/icons/shower.svg.vue';
    import PeopleIcon from '@/assets/icons/people.svg.vue';
    import PoolIcon from '@/assets/icons/pool.svg.vue';
    import HotTubIcon from '@/assets/icons/hot-tub.svg.vue';
    import PetIcon from '@/assets/icons/pet.svg.vue';
    import SkiIcon from '@/assets/icons/ski.svg.vue';
    import TennisIcon from '@/assets/icons/tennis.svg.vue';

    import CommonComponents from '@/components/Common.vue';
    import ApiObject from '@/classes/ApiObject.js';

    export default {
        components: {
            BedroomIcon,
            DoorIcon,
            ShowerIcon,
            PeopleIcon,
            PoolIcon,
            HotTubIcon,
            PetIcon,
            SkiIcon,
            TennisIcon,
            ...CommonComponents,
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },

            useBedsCount: {
                type: Boolean,
                default: false,
            },

            includeBedroomsCount: {
                type: Boolean,
                default: true,
            },

            marginBetween: {
                type: Number,
                default: 3,
            },

            // if we only need to limit the icons
            // to 4 icons (in card display)
            limited: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            marginCssClass() {
                return 'me-'+this.marginBetween;
            },

            petsLabel() {
                if ((this.property) && (this.property.petPolicy)) {
                    if (this.property.petPolicy == 1) {
                        return 'Pets Permitted';
                    }
                    else if (this.property.petPolicy == 2) {
                        return 'Pets Considered'
                    }
                }
                return null;
            },
        },
    };

</script>
